<template>
	<ParamWrapper v-bind="wrapperProps" @input-data-closed="onDataInputMenuClose">
		<component :is="component" v-bind="componentProps" v-on="componentListeners" />
		<template #input-data>
			<NumberDataInputMenu :param="param" v-on="dataInputListeners" ref="data-input-menu" />
		</template>
	</ParamWrapper>
</template>

<script>
import ParamTypeMixin from './mixins/ParamTypeMixin';
import ParamTypeExtenderDataInputMenuMixin from './mixins/ParamTypeExtenderDataInputMenuMixin';
import ExternalSourceMixin from './mixins/ExternalSourceMixin';
import UserMatchingMixin from './mixins/UserMatchingMixin';
import NumberPropertyInput from '../inputsComponents/NumberPropertyInput';
import NumberPropertyDropdownInput from '../inputsComponents/NumberPropertyDropdownInput';
import ThisFlowMixin from './mixins/ThisFlowMixin';
import NumberDataInputMenu from '../DataInputMenus/NumberDataInputMenu';
import ParamTypeHelper from './param-type-helper';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
export default {
	name: 'IntegerParamType',
	mixins: [ParamTypeMixin, ParamTypeExtenderDataInputMenuMixin, ThisFlowMixin, ExternalSourceMixin, UserMatchingMixin],
	components: { NumberPropertyInput, NumberDataInputMenu },
	computed: {
		componentConfig() {
			const EXTERNAL_VALUE_PROPS = {
				...this.$attrs,
				readonly: this.readonly,
				value: this.localValueDisplay,
				loading: this.loading,
				rules: this.fieldRules,
				inputFieldHint: this.param.placeholder,
				isUserMatching: this.isUserMatching,
				showClearButton: !isNullOrUndefinedOrEmpty(this.localValueDisplay),
				isDropdownOpen: this.showDataMenu,
				isFocused: this.isFocused,
				showDataMenu: this.showDataMenu,
				ref: 'richEditor',
			};
			const RICH_TEXT_BOX_PROPS = {
				...this.buildCommonRichTextBoxProps(),
				...this.$attrs,
				inputFieldHint: this.param.placeholder,
				value: this.localValue,
				ref: 'richEditor',
				isFocused: this.isFocused,
				showDataMenu: this.showDataMenu,
			};
			const EXTERNAL_VALUE_LISTENERS = {
				'clear-value': this.clearValue,
				'open-user-matching-dialog': this.openUserMatchingDialog,
				focus: this.onInputFocus,
				blur: this.onInputBlur,
				click: this.onInputClick,
				open: this.openDataInputMenu,
			};
			const RICH_TEXT_BOX_LISTENERS = {
				focus: this.onInputFocus,
				blur: this.onInputBlur,
				click: () => this.onInputClick(true),
				input: (val) => (this.localValue = val),
				open: this.openDataInputMenu,
				'content-updated': this.onContentUpdate,
			};

			const REGULAR_PROPERTY_INPUT_CONFIG = ParamTypeHelper.buildComponentConfigItem(
				NumberPropertyInput,
				RICH_TEXT_BOX_PROPS,
				RICH_TEXT_BOX_LISTENERS
			);
			const REGULAR_PROPERTY_DROPDOWN_INPUT_CONFIG = ParamTypeHelper.buildComponentConfigItem(
				NumberPropertyDropdownInput,
				EXTERNAL_VALUE_PROPS,
				EXTERNAL_VALUE_LISTENERS
			);
			return this.fromExternalSource ? REGULAR_PROPERTY_DROPDOWN_INPUT_CONFIG : REGULAR_PROPERTY_INPUT_CONFIG;
		},
		component() {
			return this.componentConfig.component;
		},
		componentProps() {
			return this.componentConfig.props;
		},
		componentListeners() {
			return this.componentConfig.listeners;
		},
	},
	watch: {
		componentConfig: {
			handler() {
				this.$nextTick(() => {
					this.setInputElement(this.$refs['richEditor']?.$el);
				});
			},
		},
	},
};
</script>
<style lang="scss" scoped></style>
